import { render, staticRenderFns } from "./CvGradeFeedback.vue?vue&type=template&id=30c1fd18&scoped=true&"
import script from "./CvGradeFeedback.vue?vue&type=script&lang=js&"
export * from "./CvGradeFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CvGradeFeedback.vue?vue&type=style&index=0&id=30c1fd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1fd18",
  null
  
)

export default component.exports